<template>
	<div>
		<TableList v-bind="getData" @on-radio-change="checkChange"></TableList>
		<div class="text-right">
			<vButton @click="click" theme="primary">{{$t('global.modal.confirm', { defaultValue: '确定' })}}</vButton>
			<vButton class="margin-left-10" @click="cancel" >{{$t('global.common.operation_cancel', { defaultValue: '取消' })}}</vButton>
		</div>
	</div>
</template>
<script>
import { HttpGetaddChild, HttpGetTitleAndInit } from "@/service/managechannel/managechannel";
import TableList from "@components/templates/tablelist"
export default {
	props:['flaglist','titlelist','initlist'],
	components: {
		TableList,
	},
	methods: {
		
		checkChange(rows, val) {
			// console.log(rows)
			this.rows = rows
		},
		click() {
			this.$emit('rows', this.rows)
		},
		cancel(){
			this.$emit('cancel')
		},
	},
	computed: {
		getData() {
			return {
				initFormData: {
					"search[NC_parentAccountFlag]":'-'
				},
				// interceptResponse: function(data) {
				// 	console.log(123123)
				// 	console.log(data)
				// },
				ajaxRequest: HttpGetaddChild,
				startUp: true,
				Searchs: {
					show: true,
					style: "border:none;",
					align: "left"
				},
				SearchsData: [{
					label: this.$t('erp.channelbase.channel_name', { defaultValue: "渠道名称" }),
					tag: 'vSelect',
					key: 'CN_flag',
					show: true,
					options:this.flaglist.map(function(item){
                        return {
                            value:item,
                            label:item
                        }
                    }),
                    props:{
                        filterable:true,
                    }
				}, {
					label: this.$t('erp.channelbase.channel_title', { defaultValue: "渠道标题" }),
					tag: 'vSelect',
					key: 'CN_title',
					show: true,
					options:this.titlelist.map(function(item){
                        // const {accountType}=item;
                        return {
                            value:item,
                            label:item
                        }
                    }),
                    props:{
                        filterable:true,
                    },
				},{
					label: this.$t('erp.channelbase.channel_mark', { defaultValue: "渠道标志" }),
					tag: 'vSelect',
					key: 'CN_accountInit',
					show: true,
					options:this.initlist.map(function(item){
                        // const {siteCountry}=item;
                        return {
                            value:item,
                            label:item
                        }
                    }),
                    props:{
                        filterable:true,
                    },
				}],
				columns: [{
					type: 'selection',
					width: 60,
					align: "center",
					formName: 'id',
					isRadio:true,
				}, {
					title: this.$t('erp.channelbase.channel_name', { defaultValue: "渠道名称" }),
					key: 'flag'
				}, {
					title: this.$t('erp.channelbase.channel_title', { defaultValue: "渠道标题" }),
					key: 'title'
				}, {
					title: this.$t('erp.channelbase.channel_mark', { defaultValue: "渠道标志" }),
					key: 'accountInit',
				}]
			}
		}
    },
}
</script>